import { toast } from 'react-toastify';

import { BackendRoute } from '../../../config/index';
import { QueryKey } from '../../../constants/index';
import { useIdempotentAppMutation } from '../../../hooks/use-idempotent-app-mutation.hook';
import { ApiService } from '../../../services/index';
import { PerkClaimDisplayRule, PerkClaimType } from '../perks.types';

export type PerkClaimOffer = {
  claimType: PerkClaimType;
  id: string;
} & (
  | {
      claimCode: string;
      claimDisplayRule: PerkClaimDisplayRule;
      claimType: PerkClaimType.PROMO_CODE;
    }
  | {
      claimType: PerkClaimType.LINK;
      claimUrl: string;
    }
);

export const useClaimOffer = (id: string) => {
  const {
    mutate: claimOffer,
    isPending,
    data: perkOffer,
  } = useIdempotentAppMutation([QueryKey.PERKS, QueryKey.POST, id], {
    mutationFn: (_variables, { headers }) =>
      ApiService.post<PerkClaimOffer>(
        {
          endpoint: BackendRoute.PERKS,
          routePath: [id, 'activate'],
        },
        { headers },
      ),

    onSuccess: (claim) => {
      if (
        claim.claimType === PerkClaimType.PROMO_CODE &&
        claim.claimDisplayRule === PerkClaimDisplayRule.VIA_EMAIL
      )
        toast.success('Email with promocode has been sent. Please check your inbox');
    },
  });
  return {
    claimOffer,
    isPending,
    perkOffer,
  };
};
